import React from 'react';
import PropTypes from 'prop-types';

import styles from './options.scss';

class OptionChoice extends React.Component {
    static propTypes = {
        selectionHandler: PropTypes.func.isRequired,
        isSelected: PropTypes.bool,
        title: PropTypes.string.isRequired,
        identifier: PropTypes.string.isRequired,
        language: PropTypes.string,
    };

    onClick = () => {
        this.props.selectionHandler(this.props.identifier);
    };

    render() {
        const className = `${styles.optionItem} ${styles.optionChoice}`;
        const { isSelected, language, title } = this.props;

        return (
            <button
                className={className}
                aria-pressed={isSelected}
                onClick={this.onClick}
            >
                {
                    isSelected
                        ? <i className="fa fa-check fa-fw" aria-hidden="true" />
                        : <i className="fa fa-fw" aria-hidden="true" />
                }
                <span
                    lang={language}
                >
                    {title}
                </span>
            </button>
        );
    }
}

class OptionsChoiceList extends React.Component {
    static propTypes = {
        selectionHandler: PropTypes.func.isRequired,
        choices: PropTypes.array.isRequired,
    };

    makeChoices = () => {
        const { choices } = this.props;
        return choices.map((choice) => {
            return (<OptionChoice
                {...choice}
                selectionHandler={this.props.selectionHandler}
                key={choice.identifier}
            />);
        });
    };

    render() {
        if (this.props.choices.length === 0) {
            return null;
        }

        const choiceItems = this.makeChoices();
        return <ul className={styles.buttonGroup}>{choiceItems}</ul>;
    }
}

export default OptionsChoiceList;
